import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetSessionList } from "../../../utilities/api/session/index";
import _uniq from "lodash/uniq";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}
type SessionsListType = {
  id: string;
  name: string;
  sportName: string;
  sessionPeriod: string;
  weeklyDays: string;
  totalSession: string;
  completedSessions: string;
  courtName: string;
  attendeesLimit: string | number;
  currentAttendees: string | number;
  sessionStatus: string;
  coachName: string;
  rawData: any;
};

const initialState = {
  AllSessionsData: [] as SessionsListType[],
  errorMessage: {} as ErrorMessageType,
};

export const AllSessionList = createAsyncThunk(
  "SessionList/AllSessionList",
  (facilityId: string) => GetSessionList(facilityId)
);

const SessionListSlice = createSlice({
  name: "SessionList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(
        AllSessionList.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action?.payload?.statusCode === 200) {
            state.AllSessionsData = action.payload.data.rows.map(
              (item: any) => ({
                id: item.id,
                name: item?.name,
                sportName: item?.sport?.name,
                sessionPeriod: item?.endDate
                  ? `${item?.startDate} to ${item?.endDate}`
                  : `${item?.startDate} to -`,
                weeklyDays: _uniq(
                  item?.sessionSlots?.map?.((_slot: any) =>
                    _slot?.sessionDay?.substring?.(0, 3)?.toUpperCase?.()
                  )
                )?.join("-"),
                totalSession: item?.endDate ? item?.totalNoOfSessions : "-",
                completedSessions: item?.completedSessions,
                courtName: item?.court?.name,
                attendeesLimit: item?.maxNoOfAttendees ? item?.maxNoOfAttendees : "-",
                currentAttendees: item?.currentAttendees,
                sessionStatus: item?.status,
                coachName: `${item?.coach?.firstName} ${item?.coach?.lastName}`,
                isActive: item.isActive ? "Active" : "Inactive",

                rawData: item,
              })
            );
          }
        }
      )
      .addCase(AllSessionList.rejected, (state, action) => {
        state.errorMessage = { message: messages.error.internal_server_error };
      });

  },
});

export default SessionListSlice.reducer;
